'use client';
import { type Product } from '@curology/product-service-sdk';
import { Checkbox } from '@curology/ui-components-web/react/Checkbox';
import { LockIcon } from '@curology/ui-components-web/react/Icon/icons/LockIcon';
import { Image } from '@curology/ui-components-web/react/Image';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type PreviousFormulaData } from '@/services/resubscriptionService/types';

import { type ProductPriceMap, centsToDollarsAndCents } from '../utils/helpers';

const ProductCard = ({
  product,
  productPriceMap,
  formulationData,
  showEditIcon,
}: {
  product: Product;
  productPriceMap: ProductPriceMap;
  formulationData?: PreviousFormulaData;
  showEditIcon: boolean;
}) => {
  const price = centsToDollarsAndCents(productPriceMap[product.slug]);

  return (
    <div className="cur-bg-surface-neutral cur-rounded-sm cur-text-primary cur-p-2">
      <div className="cur-flex cur-p-2">
        <div className="cur-w-[30%] cur-align-middle">
          <Image
            src={product.thumbnailImage?.at(0)?.urlSmall}
            alt={product.name ?? ''}
          />
        </div>
        <dl className="cur-flex cur-flex-col cur-pl-2 cur-align-top cur-text-left cur-w-full">
          <div className="cur-flex cur-justify-between">
            <Typography size="body" weight="bold" className="cur-pb-2">
              {product.name}
              {product.isRx ? <sup>Rx</sup> : null}
            </Typography>
            {showEditIcon &&
              (product.isRx ? <LockIcon size="sm" /> : <Checkbox size="sm" />)}
          </div>
          <Typography size="meta" weight="bold" className="cur-pb-2">
            {price}
          </Typography>
          {formulationData &&
            formulationData.ingredients.map((ingredient, i) => (
              <Typography key={i} size="meta">
                {ingredient.name} {ingredient.percentage}
              </Typography>
            ))}
          {product.shortDescription && !formulationData && (
            <Typography
              size="meta"
              dangerouslySetInnerHTML={{
                __html: product.shortDescription || product.description,
              }}
            />
          )}
        </dl>
      </div>
      <hr className="cur-bg-surface-disabled cur-border-0 cur-h-[2px] cur-mt-4" />
    </div>
  );
};

export default ProductCard;
